import header from "./couple-packing-stuff-plenty-cardboard-boxes.jpg";
import section1 from "./medium-shot-delivery-man-talking-phone.jpg";
import section2 from "./renovating-office.jpg";
import section3 from "./side-view-buyer-signing-document.jpg";
import section4 from "./watch-out-boxes-are-falling.jpg";
import section5 from "./close-up-people-working-from-home.jpg";
import section6 from "./young-movers-unloading-boxes-van.jpg";
import section7 from "./close-up-hands-holding-box.jpg";

export {
  header,
  section1,
  section2,
  section3,
  section4,
  section5,
  section6,
  section7,
};
